import React, { useState, useEffect } from "react";
import axios from "axios";
import TrafficList from "./components/TrafficList";

function App() {
  const [trafficData, setTrafficData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [streets, setStreets] = useState([]);

  useEffect(() => {
    const fetchTrafficData = async () => {
      try {
        const response = await axios.get(`https://verkehr.radioerzheimat.de/static/data/traffic.json?ts=${new Date().getTime()}`);
        const data = Object.values(response.data.traffic).flat();

        // Sammle alle Straßennummern
        const streetNumbers = [...new Set(data.map(item => item.roadName).filter(Boolean))];

        setTrafficData(data);
        setFilteredData(data);
        setStreets(streetNumbers);
		
        // Höhe des iFrames nach Laden der Daten anpassen
        setTimeout(() => {
          window.parent.postMessage({ height: document.body.scrollHeight }, "*");
        }, 100); // Kleiner Timeout für sicheres Rendering
      } catch (error) {
        console.error("Fehler beim Abrufen der Daten:", error);
      }
    };

    fetchTrafficData();

    const interval = setInterval(fetchTrafficData, 60000);

    return () => clearInterval(interval);
  }, []);

  const [selectedStreet, setSelectedStreet] = useState(null);

  const filterByStreet = (street) => {
    if (selectedStreet === street) {
      // Falls dieselbe Straße erneut angeklickt wird, Filter zurücksetzen
      setFilteredData(trafficData);
      setSelectedStreet(null);
    } else {
      // Ansonsten nach der gewählten Straße filtern
      const filtered = trafficData.filter(item => item.roadName === street);
      setFilteredData(filtered);
      setSelectedStreet(street);
    }
  };  
  
  useEffect(() => {
    setTimeout(() => {
      window.parent.postMessage({ height: document.body.scrollHeight }, "*");
    }, 100);
  }, [filteredData]);

  return (
    <div className="trafficData">

      <div className="trafficFilters">
        {streets.map((street) => (
          <button key={street} onClick={() => filterByStreet(street)}>
            {street}
          </button>
        ))}
      </div>

      <TrafficList data={filteredData} />
    </div>
  );
}

export default App;